import Vue from 'vue';
import VueFusionCharts from 'vue-fusioncharts';
import FusionCharts from 'fusioncharts';

// register VueFusionCharts component
Vue.use(VueFusionCharts, FusionCharts);
